module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crowd-container"
  }, [_c('div', {
    staticClass: "crowd-list"
  }, [_vm._l((_vm.selectedCrowd), function(item) {
    return _c('div', {
      staticClass: "crowd-item",
      on: {
        "click": function($event) {
          _vm.showCrowd(item)
        }
      }
    }, [_c('span', {
      staticClass: "fa-icon",
      style: (item.style)
    }, [_c('i', {
      staticClass: "fa fa-user-circle-o"
    })]), _c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.dropCrowd(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedCrowd.length < 5),
      expression: "selectedCrowd.length < 5"
    }],
    staticClass: "crowd-item crowd-add",
    on: {
      "click": _vm.openCrowd
    }
  }, [_vm._m(0), _c('span', [_vm._v("添加人群")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-icon"
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1e77d62a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e77d62a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/crowTags.vue
// module id = 725
// module chunks = 0